import { Helmet } from 'react-helmet';
import Industries from '../components/Industries';

export default function IndustriesPage() {
  return (
    <>
      <Helmet>
        <title>Industries We Serve | The Prisu Experts</title>
        <meta
          name="description"
          content="From healthcare to automotive, explore how The Prisu Experts empowers industries with high-quality AI data solutions."
        />
      </Helmet>
      <Industries />
    </>
  );
}
